const state = {
  translationModules: [],
  translationFields: [],
  versionHistory: [],
  preFilledData: [],
};

export default state;
